import debug from 'debug';
import SitecoreApi from './sitecoreApi';

const log = debug('SitecoreApi:Profile');

class Profile extends SitecoreApi {
	userProfile(path) {
		const profilePath = path || '';
		const url = '/api/v7/profile' + profilePath;
		return this.get(url);
	}

	setUserProfile(path, body) {
		const profilePath = path || '';
		const url = '/api/v7/profile' + profilePath;
		log('post()', url, body);
		return this.post(url, body);
	}
}

export default Profile;
